import NO_LOGO from "./no_logo.png";

export default NO_LOGO;
